import styled from 'styled-components';

interface ButtonProps {
    secondary?: boolean;
    sm?: boolean;
    full?: boolean;
    withArrow?: boolean;
}

export const Button = styled.button<ButtonProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme, disabled, secondary }) => disabled ? ( secondary ? 'transparent' : 'rgba(0, 0, 0, .12)') : ( secondary ? 'transparent' : "#2372B9")};
    border-style: ${({ secondary }) => secondary ? 'solid' : 'none'};
    border-width: ${({ secondary }) => secondary ? '1px' : 0};
    border-color: ${({ secondary, disabled, theme }) => secondary ? ( disabled ? '#E6E6E6' : "#2372B9" ) : 'transparent'};
    padding: ${({ sm }) => sm ? '8px 12px' : '16px 40px'};
    font-size: ${({ sm }) => sm ? '13px' : '15px'};
    border-radius: 50px;
    font-weight: bold;
    width: ${({ full }) => full ? '100%' : 'auto'};
    color: ${({ secondary, disabled, theme }) => disabled ? ( secondary ? '#E6E6E6' : 'rgba(0, 0, 0, .26)' ) : ( secondary ? '#2372B9' : '#fff' )};
    cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
    transition: all .3s;
    box-shadow: ${({ secondary, disabled }) => (disabled || secondary) ? 'none' : '0 0 0 rgba(255, 255, 255, 0)'};

    &:hover {
        color: ${({ secondary, disabled }) => secondary ? '#2372B9' : (disabled ? 'rgba(0, 0, 0, .26)' : '#fff')};
        border-color: ${({ secondary }) => secondary ? '#2372B9' : 'transparent'};
        box-shadow: ${({ secondary, disabled }) => (disabled || secondary) ? 'none' : '0 8px 16px rgb(35, 114, 185 , 0.2)'};
    }

    ::after {
        display: ${({ withArrow }) => withArrow ? 'inline-flex' : 'none'};
        content: ' ';
        width: 20px;
        height: 20px;
        mask: url('/images/ChevronRight.svg') 0 0 no-repeat;
        mask-size: cover;
        background-color: ${({ secondary, disabled, theme }) => disabled ? ( secondary ? '#E6E6E6' : 'rgba(0, 0, 0, .26)' ) : ( secondary ? "#2372B9" : '#fff' )};
        margin-left: 6px;
        margin-right: -6px;
    }
`